import React, { useContext, useState } from 'react';

import { navigate } from '@gatsbyjs/reach-router';
import Avatar from '@material-ui/core/Avatar';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { AppContext } from '../../contexts/app-context';
import {
  Box, Button, Card, CardActions, CardContent, CardHeader, FormControlLabel, Switch, Typography
} from '../../utils/material-ui-core';

const ProfileCard = () => {
  const pageStyles = LocalPageStyles();

  const { user, logoff } = useContext(AppContext);
  const [permissionListVisible, setPermissionListVisible] = useState<boolean>(false);
  const userPermissionList = ["CRM Batch Admin Read", "CRM Batch Admin Write", "Enrollment Batch Admin Error Correction", "Enrollment Batch Admin Read", "Enrollment Batch Admin Turn Off Job", "Enrollment Batch Admin Write", "Enrollment Batch Validate", "Fulfillment Admin Read", "Manual Order Admin", "Onboarding Admin Read", "Onboarding Company Admin Write", "Onboarding Kit Admin Write", "Onboarding Kit Approver", "Onboarding Program Admin Write", "Replacement Admin Read", "SKU Admin Read", "Status Batch Admin Read", "Subscription Admin Read"];

  const handleLogoff = () => {
    logoff();
    navigate("/Login");
  };

  const handlePermissionDisplayChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPermissionListVisible(event.target.checked);
  };

  return (
    <Card className={pageStyles.cardRoot} variant="outlined">
      <CardHeader avatar={<Avatar color="secondary">KG</Avatar>} title={user.information?.first + "  " + user.information?.last} subheader={user.email} />
      <CardContent>
        <Box p={1} width={1}>
          <FormControlLabel control={<Switch checked={permissionListVisible} onChange={handlePermissionDisplayChange} name="checkedB" color="secondary" />} label={permissionListVisible ? "Hide Permissions" : "Show Permissions"} />

          {permissionListVisible ? (
            <Box width={1} className={pageStyles.permissionContainer}>
              {userPermissionList.map((item, index) => {
                return (
                  <Typography variant="body1" key={index} noWrap className={pageStyles.permissionItem}>
                    {item}
                  </Typography>
                );
              })}
            </Box>
          ) : null}
        </Box>
      </CardContent>
      <CardActions>
        <Box p={3} width={1}>
          <Button id="login-button-login" variant="outlined" color="primary" fullWidth={true} onClick={handleLogoff}>
            LOGOUT
          </Button>
        </Box>
      </CardActions>
    </Card>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardRoot: {
      width: 350,
      maxWidth: 350,
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[100],
      paddingTop: theme.spacing(2),
    },
    permissionContainer: {
      textOverflow: "ellipsis",
      wordWrap: "break-word",
      height: "150px",
      overflowY: "auto",
      overflowX: "hidden",
      paddingTop: 20,
    },
    permissionItem: {
      width: "inherit",
      textOverflow: "ellipsis",
      wordWrap: "break-word",
    },
  })
);

export default ProfileCard;
